import { Tracker } from '@/service'
import { log } from '@/utils'
// import router from '@/router'
import Router from '@/router/index'
import { getRouter } from '@/service/tracker/utils'
function getQuery (params) {
  let query = { ...params }
  const current = Router.history.current
  // console.log('getQuery-current',current)
  const routerVal = getRouter(current.path)
  // console.log('getQuery-routerVal',routerVal)
  query = Object.assign(query, routerVal)
  query.action = 'watch'
  return query
}
const UVservice = {
  // 上报UV
  ['sp_save_upv'] (params) {
    const data = getQuery(params)
    Tracker.trackEvents('sp_save_upv', '上报UV', data)
  }
}

export default UVservice
